function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2713 5.91818L9.92766 5.8689L9.63635 13.8241L10.98 13.8732L11.2713 5.91818Z",
  fill: "#333333"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 7.32776,
  y: 5.89355,
  width: 1.34453,
  height: 7.95521,
  fill: "#333333"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.36348 13.8239L6.07217 5.86871L4.72852 5.91803L5.01986 13.8732L6.36348 13.8239Z",
  fill: "#333333"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 3.92155V2.57703H16V3.92155H14.5764L13.4649 16.5517C13.4346 16.8989 13.1438 17.1653 12.7953 17.1653H3.18205C2.83361 17.1653 2.54294 16.8991 2.51247 16.552L1.40102 3.92155H0ZM3.79765 15.8208H12.1795L13.2267 3.92155H2.75071L3.79765 15.8208Z",
  fill: "#333333"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1961 0H5.80391C5.18609 0 4.68347 0.502621 4.68347 1.12044V3.2493H6.028V1.34453H9.97199V3.2493H11.3165V1.12044C11.3165 0.502621 10.8139 0 10.1961 0Z",
  fill: "#333333"
});

var SvgBin = function SvgBin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bin.202acd21.svg";
export { ForwardRef as ReactComponent };